export interface LoginForm {
    username: string
    password: string
}

export const loginInitialState = {
  username: '',
  password: '',
}
